import {AttributesOptionListDto} from '../../../../../../../shared/services/specification-attribute/dto/attributes-option-dto';
import {Row, Col, Table} from 'antd';
import {useState} from 'react';
import {
  INDEX_PAGE_SIZE_DEFAULT,
  INDEX_PAGE_SIZE_OPTIONS,
} from '../../../../../../../shared/constants/AppConst';
import TableColumn from './columns';
import {popupConfirm} from '../../../../../../../shared/components/popup-confirm';
import {specificationAttributeService} from '../../../../../../../shared/services/specification-attribute';
import {useIntl} from 'react-intl';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import useTableV2 from 'src/shared/hooks/useTableV2';

interface IAttributesOptionTableProps {
  isAttributesOptionLoading: boolean;
  attributesOption: AttributesOptionListDto[];
  onEditAttributeOption: (item: AttributesOptionListDto) => void;
  onFinish: () => void;
}

const AttributesOptionTable = (props: IAttributesOptionTableProps) => {
  const {
    isAttributesOptionLoading,
    attributesOption,
    onEditAttributeOption,
    onFinish,
  } = props;

  const {messages} = useIntl();

  const [pagination, setPagination] = useState({
    page: 1,
    limit: INDEX_PAGE_SIZE_DEFAULT,
  });

  const [pageSizeOptions] = useState<string[]>(INDEX_PAGE_SIZE_OPTIONS);

  const {locale}: any = useLocaleContext();
  const {showTotal, ...tableV2} = useTableV2();

  const tablePagination = {
    total: attributesOption?.length,
    pageSizeOptions: pageSizeOptions,
    pageSize: pagination.limit,
    showSizeChanger: true,
    showTotal,
    current: pagination.page,
    onShowSizeChange: async (current: any, PageSize: any) => {
      setPagination({limit: PageSize, page: current});
    },
    onChange: (page: any, pageSize: any) => {
      setPagination({limit: pageSize, page: page});
    },
  };

  const handleClickOnUpdate = (item: AttributesOptionListDto) => {
    onEditAttributeOption(item);
  };

  const deleteAttributeOption = (record: AttributesOptionListDto) => {
    popupConfirm(async () => {
      try {
        await specificationAttributeService.deleteOption(record.Id);
        await onFinish();
      } catch (error) {
        console.error(error);
      }
    }, `${messages['commom.areYouSureYouWantToDelete'].toString()}` + ' ' + [record?.Locales?.find((item) => item.LanguageId === locale.code)?.LocaleValue ?? record.Name] + `?`);
  };

  return (
    <Row gutter={[0, 48]}>
      <Col span={24}>
        <Table
          columns={TableColumn(handleClickOnUpdate, deleteAttributeOption)}
          dataSource={attributesOption}
          rowKey={(record: AttributesOptionListDto) => record.Id?.toString()}
          loading={isAttributesOptionLoading}
          bordered={true}
          pagination={tablePagination}
          {...tableV2}
        />
      </Col>
    </Row>
  );
};

export default AttributesOptionTable;
